import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=ab95f5d2&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=ab95f5d2&prod&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=ab95f5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab95f5d2",
  null
  
)

export default component.exports